// MenuItemsPage.jsx
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

// import { MenuItem as MenuItemEntity } from "@/entities/MenuItem";
// import { Module } from "@/entities/Module";
// import { Package } from "@/entities/Package";
// import { Role } from "@/entities/Role";
// import { useToast } from "@/components/ui/use-toast";
// import useAppLevelAuth from "@/hooks/useAppLevelAuth";

import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  FormLabel,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";

import "../../Style/MenuItemsPage.scss";
import authHeader from "../../Auth/authHeader";
import { GetMenuItems } from "../../GetData/MenuItems";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { GetSystemRoles } from "../../GetData/SystemRoles";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import { getMenuItemByID } from "../../GetData/MenuItemByID";
export default function MenuItemsPage() {
  //   const { isLoggedIn } = useAppLevelAuth();
  //   const { toast } = useToast();
  const toast = null;
  const history = useHistory();
  // const [searchParams] = useSearchParams();
  const location = useLocation();

  const headers = authHeader();
  const query = new URLSearchParams(location.search);
  const mode = query.get("mode") || "list";
  // const mode = searchParams.get("mode") || "list";
  // const mode = "views";
  const itemId = query.get("id");
  // const itemId = 1;

  const [menuItems, setMenuItems] = useState([]);
  const [modules, setModules] = useState([]);
  const [packages, setPackages] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    icon: "",
    path: "",
    componentKey: "",
    parentId: "",
    orderNr: 0,
    isGlobal: false,
    isActive: true,
    moduleIds: [],
    packageIds: [],
    rolePermissions: [],
  });

  const isViewMode = mode === "view";

  const buildMenuItemsUrl = (params) => {
    const base = "/configuration/menuItems";
    if (!params) return base;
    const query = new URLSearchParams(params).toString();
    return `${base}?${query}`;
  };

  const returnToList = (params) => {
    const base = "/configuration/menuItems";
    if (!params) return base;
    const query = new URLSearchParams(params).toString();
    return `${base}?${query}`;
  };

  //   useEffect(() => {
  //     if (!isLoggedIn) return;
  //     loadData();
  //   }, [isLoggedIn]);

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && itemId) {
      loadMenuItem(itemId);
    } else if (mode === "add") {
      resetForm();
    }
  }, [mode, itemId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [menuData, moduleData, packageData, roleData] = await Promise.all([
        // MenuItemEntity.list("orderNr:asc"),
        // Module.list("createdAt:desc"),
        // Package.list("createdAt:desc"),
        // Role.list("createdAt:desc"),
      ]);

      setMenuItems(menuData || []);
      setModules(moduleData || []);
      setPackages(packageData || []);
      setRoles(roleData || []);
    } catch (error) {
      console.error("Error loading data:", error);
      toast({
        title: "Error",
        description: "Failed to load data",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const loadMenuItem = async (id) => {
    try {
      const item = await getMenuItemByID(headers, id);

      console.log(item);

      // const item = [];
      setFormData({
        title: item.Title || "",
        icon: item.Icon || "",
        path: item.Path || "",
        componentKey: item.ComponentKey || "",
        parentId: item.ParentID || "",
        orderNr: item.OrderNo || 0,
        isGlobal: item.IsGlobal || false,
        isActive: item.IsActive !== undefined ? item.isActive : true,
        moduleIds: item.ModuleIds || [],
        packageIds: item.PackageIDs || [],
        rolePermissions: item.RolePermissions || [],
      });
    } catch (error) {
      // toast({
      //   title: "Error",
      //   description: "Failed to load menu item",
      //   variant: "destructive",
      // });
      errorAlert("Failed to load menu item");
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      icon: "",
      path: "",
      componentKey: "",
      parentId: "",
      orderNr: 0,
      isGlobal: false,
      isActive: true,
      moduleIds: [],
      packageId: [],
      rolePermissions: [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      title: formData.title,
      icon: formData.icon,
      path: formData.path,
      componentKey: formData.componentKey,
      parentId: formData.parentId ? Number(formData.parentId) : null,
      orderNr: Number(formData.orderNr),
      isGlobal: formData.isGlobal,
      isActive: formData.isActive,
      // packageId: Number(formData.packageId),
      PackageIDs: formData.packageIds.map((x) => Number(x)),
      moduleIds: formData.moduleIds.map((x) => Number(x)),
      rolePermissions: (formData.rolePermissions || []).map((rp) => ({
        roleId: Number(rp.roleId),
        canView: rp.canView,
        canAdd: rp.canAdd,
        canEdit: rp.canEdit,
        canDelete: rp.canDelete,
      })),
    };

    try {
      if (mode === "edit" && itemId) {
        // rolePermissions;
        // await MenuItemEntity.update(itemId, formData);
        // toast({
        //   title: "Success",
        //   description: "Menu item updated successfully",
        // });
        handleSuccess("u editua");
      } else {
        // await MenuItemEntity.create(formData);
        await axios.post(ApiLink.API_URL + "MenuItem/insert", payload, {
          headers,
        });
        // toast({
        //   title: "Success",
        //   description: "Menu item created successfully",
        // });
        handleSuccess("Menu item created successfully");
        // loadAll();
        // setFormData({
        //   title: "",
        //   icon: "",
        //   path: "",
        //   componentKey: "",
        //   parentId: "",
        //   orderNr: 0,
        //   isGlobal: false,
        //   isActive: true,
        //   moduleIds: [],
        //   packageIds: [],
        //   rolePermissions: [],
        // });
      }
      // console.log(formData);

      //   navigate(buildMenuItemsUrl());
      // loadData();
    } catch (error) {
      // toast({
      //   title: "Error",
      //   description: "Failed to save menu item",
      //   variant: "destructive",
      // });
      errorAlert("error");
      console.log(formData);
    }
  };

  const openDeleteDialog = (item) => {
    setItemToDelete(item);
    setDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      //   await MenuItemEntity.delete(itemToDelete.id);
      toast({
        title: "Success",
        description: "Menu item deleted successfully",
      });
      closeDeleteDialog();
      loadData();
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete menu item",
        variant: "destructive",
      });
    }
  };

  const handleRoleToggle = (roleId, checked) => {
    if (checked) {
      setFormData((prev) => ({
        ...prev,
        rolePermissions: [
          ...(prev.rolePermissions || []),
          {
            roleId,
            canView: false,
            canAdd: false,
            canEdit: false,
            canDelete: false,
          },
        ],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        rolePermissions: (prev.rolePermissions || []).filter(
          (rp) => rp.roleId !== roleId
        ),
      }));
    }
  };

  const handlePermissionChange = (roleId, permission, checked) => {
    setFormData((prev) => ({
      ...prev,
      rolePermissions: (prev.rolePermissions || []).map((rp) =>
        rp.roleId === roleId ? { ...rp, [permission]: checked } : rp
      ),
    }));
  };

  // const handleModuleToggle = (moduleId, checked) => {
  //   if (checked) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       moduleIds: [...(prev.moduleIds || []), moduleId],
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       moduleIds: (prev.moduleIds || []).filter((id) => id !== moduleId),
  //     }));
  //   }
  // };
  const handleModuleToggle = (moduleId, checked) => {
    setFormData((prev) => {
      const current = prev.moduleIds || [];

      const updated = checked
        ? [...current, moduleId]
        : current.filter((id) => id !== moduleId);
      return {
        ...prev,
        moduleIds: updated,
      };
    });
  };

  const handlePackToggle = (packID, checked) => {
    setFormData((prev) => {
      const current = prev.packageIds || [];

      const updated = checked
        ? [...current, packID]
        : current.filter((id) => id !== packID);
      return {
        ...prev,
        packageIds: updated,
      };
    });
  };

  const loadAll = async () => {
    try {
      const [menuData, packageData, moduleData, roleData] = await Promise.all([
        GetMenuItems(headers),
        getSystemPackage(headers),
        getSystemModules(headers), // thirrja jote e tretë
        GetSystemRoles(headers), // thirrja jote e katërt
      ]);

      if (menuData) setMenuItems(menuData);
      if (packageData) setPackages(packageData);
      if (moduleData) setModules(moduleData);
      if (roleData) setRoles(roleData);
    } catch (error) {
      errorAlert("Gabim gjatë ngarkimit:");
    }
  };
  useEffect(() => {
    // const loadAll = async () => {
    //   try {
    //     const [menuData, packageData, moduleData, roleData] = await Promise.all(
    //       [
    //         GetMenuItems(headers),
    //         getSystemPackage(headers),
    //         getSystemModules(headers), // thirrja jote e tretë
    //         GetSystemRoles(headers), // thirrja jote e katërt
    //       ]
    //     );

    //     if (menuData) setMenuItems(menuData);
    //     if (packageData) setPackages(packageData);
    //     if (moduleData) setModules(moduleData);
    //     if (roleData) setRoles(roleData);
    //   } catch (error) {
    //     errorAlert("Gabim gjatë ngarkimit:");
    //   }
    // };

    loadAll();
  }, []);

  const filteredMenuItems = (menuItems || []).filter(
    (item) =>
      item.Title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.Path?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  //Pjesa per select input field menu parents
  const [parentField, setParentField] = useState(null);
  const handleAutocompleteChangeParent = (event, value) => {
    if (value && value.MenuID) {
      setFormData({
        ...formData,
        parentId: value ? value.MenuID : "",
      });
      setParentField(value);
    } else {
      // Në rast se vlera është pastruar
      setFormData({
        ...formData,
        parentId: "",
      });
      setParentField(null);
    }
  };

  const defaultPropsParent = {
    options: menuItems,
    getOptionLabel: (option) => `${option.Title} - ${option.OrderNo}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.Title}
            <br />
            Numri rendor -{option.OrderNo}
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field menu package
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackage = (event, value) => {
    if (value && value.PackageID) {
      setFormData({
        ...formData,
        packageId: value ? value.PackageID : "",
      });
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setFormData({
        ...formData,
        PackageID: "",
      });
      setPackageField(null);
    }
  };

  const defaultPropsPackage = {
    options: packages,
    getOptionLabel: (option) =>
      `${option.PackageName} - ${option.YearlyPrice}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
            Cmimi vjetor -{option.YearlyPrice}
          </span>
        </li>
      </>
    ),
  };

  //   if (!isLoggedIn) return null;

  if (!loading && mode === "list") {
    return (
      <div className="menu-items-page">
        <div className="mi-stack mi-stack--lg">
          <div className="mi-loading-card pulse-loader" />
          <div className="mi-loading-card mi-loading-card--tall pulse-loader" />
        </div>
      </div>
    );
  }

  // ADD / EDIT / VIEW FORM
  if (mode === "add" || mode === "edit" || mode === "view") {
    return (
      <div className="menu-items-page">
        <div className="mi-stack mi-stack--lg">
          <div className="mi-header mi-header--between">
            <div>
              <h1 className="mi-title">
                {mode === "add"
                  ? "Add Menu Item"
                  : mode === "edit"
                  ? "Edit Menu Item"
                  : "View Menu Item"}
              </h1>
              <p className="mi-subtitle">
                {mode === "add"
                  ? "Create a new menu item"
                  : mode === "edit"
                  ? "Update menu item details"
                  : "View menu item details"}
              </p>
            </div>
            <Button
              variant="outlined"
              onClick={() => {
                loadAll(); // funksioni yt shtesë që duhet të ekzekutohet
                history.push("/configuration/menuItems"); // navigimi
              }}
              className="mi-btn-back"
            >
              <ArrowBackIcon className="mi-icon-left" />
              Back to List
            </Button>
          </div>

          <form onSubmit={handleSubmit}>
            <Card className="mi-card">
              <CardContent className="mi-card-content mi-card-content--lg">
                {/* Basic Information */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Basic Information</h3>
                  <div className="mi-grid mi-grid--2cols">
                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Title *</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.title}
                        onChange={(e) =>
                          setFormData({ ...formData, title: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="Enter menu title"
                        required
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Title"
                      variant="filled"
                      value={formData.title}
                      onChange={(e) =>
                        setFormData({ ...formData, title: e.target.value })
                      }
                      disabled={isViewMode}
                      placeholder="Enter menu title"
                      required
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Icon</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.icon}
                        onChange={(e) =>
                          setFormData({ ...formData, icon: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="e.g., Home, Settings"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Icon"
                      variant="filled" // ose "filled" nëse e do në atë stil
                      value={formData.icon}
                      onChange={(e) =>
                        setFormData({ ...formData, icon: e.target.value })
                      }
                      disabled={isViewMode}
                      placeholder="e.g., Home, Settings"
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">Path *</FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.path}
                        onChange={(e) =>
                          setFormData({ ...formData, path: e.target.value })
                        }
                        disabled={isViewMode}
                        placeholder="/path/to/page"
                        required
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Path *"
                      variant="filled"
                      value={formData.path}
                      onChange={(e) =>
                        setFormData({ ...formData, path: e.target.value })
                      }
                      disabled={isViewMode}
                      placeholder="/path/to/page"
                      required
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Component Key
                      </FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        value={formData.componentKey}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            componentKey: e.target.value,
                          })
                        }
                        disabled={isViewMode}
                        placeholder="ComponentName"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Component Key"
                      variant="filled"
                      value={formData.componentKey}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          componentKey: e.target.value,
                        })
                      }
                      disabled={isViewMode}
                      placeholder="ComponentName"
                      className="mi-input"
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Parent Menu
                      </FormLabel>
                      <Select
                        className="mi-input"
                        value={formData.parentId}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            parentId: e.target.value,
                          })
                        }
                        disabled={isViewMode}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>None (Root Level)</em>
                        </MenuItem>
                        {(menuItems || []).map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.Title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl> */}
                    <Autocomplete
                      {...defaultPropsParent}
                      id="include-input-in-list"
                      includeInputInList
                      value={parentField}
                      onChange={handleAutocompleteChangeParent}
                      isOptionEqualToValue={(option, value) =>
                        option.MenuID === value.MenuID
                      } // Shto funksionin isOptionEqualToValue
                      renderInput={(params) => (
                        <TextField
                          // style={{ width: "95%" }}
                          {...params}
                          label="zgjedh menun kryesore"
                          variant="filled"

                          // variant="filled"
                          //   onKeyPress={handleKeyPress}
                        />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: 4 * 48, // 48px është lartësia default e një opsioni
                        },
                      }}
                    />

                    {/* <FormControl
                      fullWidth
                      size="small"
                      className="mi-field-control"
                    >
                      <FormLabel className="mi-field-label">
                        Order Number
                      </FormLabel>
                      <OutlinedInput
                        className="mi-input"
                        type="number"
                        value={formData.orderNr}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            orderNr: parseInt(e.target.value, 10) || 0,
                          })
                        }
                        disabled={isViewMode}
                        placeholder="0"
                      />
                    </FormControl> */}
                    <TextField
                      fullWidth
                      size="small"
                      label="Order Number"
                      variant="filled"
                      type="number"
                      value={formData.orderNr}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          orderNr: parseInt(e.target.value, 10) || 0,
                        })
                      }
                      disabled={isViewMode}
                      placeholder="0"
                      className="mi-input"
                    />
                  </div>
                </div>

                {/* Status Flags */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Status</h3>
                  <div className="mi-status-row">
                    <FormControlLabel
                      className="mi-checkbox-row"
                      control={
                        <Checkbox
                          checked={formData.isGlobal}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isGlobal: e.target.checked,
                            })
                          }
                          disabled={isViewMode}
                        />
                      }
                      label="Is Global"
                    />
                    <FormControlLabel
                      className="mi-checkbox-row"
                      control={
                        <Checkbox
                          checked={formData.isActive}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isActive: e.target.checked,
                            })
                          }
                          disabled={isViewMode}
                        />
                      }
                      label="Is Active"
                    />
                  </div>
                </div>

                {/* Package Selection */}
                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Pakot e systemit</h3>
                  <Autocomplete
                    {...defaultPropsPackage}
                    id="include-input-in-list"
                    includeInputInList
                    value={packageField}
                    onChange={handleAutocompleteChangePackage}
                    isOptionEqualToValue={(option, value) =>
                      option.PackageID === value.PackageID
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="zgjedh pakon"
                        variant="filled"
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 4 * 48, 
                      },
                    }}
                  /> */}
                {/* <FormControl
                    fullWidth
                    size="small"
                    className="mi-field-control"
                  >
                    <FormLabel className="mi-field-label">
                      Select Package
                    </FormLabel>
                    <Select
                      className="mi-input"
                      value={formData.packageId}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          packageId: e.target.value,
                        })
                      }
                      disabled={isViewMode}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {(packages || []).map((pkg) => (
                        <MenuItem key={pkg.id} value={pkg.id}>
                          {pkg.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                {/* </div> */}

                <div className="mi-section">
                  <h3 className="mi-section-title">Pakot</h3>

                  <div className="mi-modules-grid">
                    {(packages || []).map((pack) => {
                      const isChecked = (formData.packageIds || []).includes(
                        pack.PackageID
                      );

                      return (
                        <div
                          key={pack.PackageID}
                          className="mi-module-card"
                          onClick={() => {
                            handlePackToggle(pack.PackageID, !isChecked);
                          }}
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={(e) => {
                              e.stopPropagation(); // SHUMË E RËNDËSISHME! NDALON DY KLIKIME
                              handleModuleToggle(
                                pack.PackageID,
                                e.target.checked
                              );
                            }}
                            disabled={isViewMode}
                          />

                          <span className="mi-module-label">
                            {pack.PackageName}
                          </span>
                        </div>
                      );
                    })}

                    {(packages || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë Pako</p>
                    )}
                  </div>
                </div>

                {/* Module Selection */}
                <div className="mi-section">
                  <h3 className="mi-section-title">Modulet</h3>

                  <div className="mi-modules-grid">
                    {(modules || []).map((module) => {
                      const isChecked = (formData.moduleIds || []).includes(
                        module.ModuleID
                      );

                      return (
                        <div
                          key={module.ModuleID}
                          className="mi-module-card"
                          onClick={() => {
                            handleModuleToggle(module.ModuleID, !isChecked);
                          }}
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={(e) => {
                              e.stopPropagation(); // SHUMË E RËNDËSISHME! NDALON DY KLIKIME
                              handleModuleToggle(
                                module.ModuleID,
                                e.target.checked
                              );
                            }}
                            disabled={isViewMode}
                          />

                          <span className="mi-module-label">
                            {module.ModuleName}
                          </span>
                        </div>
                      );
                    })}

                    {(modules || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë modul</p>
                    )}
                  </div>
                </div>

                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Modulet</h3>
                  <div className="mi-modules-grid">
                    {(modules || []).map((module) => (
                      <div key={module.ModuleID} className="mi-module-card">
                        <Checkbox
                          checked={(formData.moduleIds || []).includes(
                            module.ModuleID
                          )}
                          onChange={(e) =>
                            handleModuleToggle(module.ModuleID, e.target.checked)
                          }
                          disabled={isViewMode}
                        />
                        <span className="mi-module-label">{module.ModuleName}</span>
                      </div>
                    ))}
                    {(modules || []).length === 0 && (
                      <p className="mi-empty-text">Nuk ka asnjë mmodul</p>
                    )}
                  </div>
                </div> */}

                {/* Role Permissions */}
                {/* <div className="mi-section">
                  <h3 className="mi-section-title">Rolet</h3>
                  <div className="mi-role-list">
                    {(roles || []).map((role) => {
                      const rolePermission = (
                        formData.rolePermissions || []
                      ).find((rp) => rp.roleId === role.Id);
                      const isRoleSelected = !!rolePermission;

                      return (
                        <div key={role.id} className="mi-role-card">
                          <div className="mi-role-header">
                            <Checkbox
                              checked={isRoleSelected}
                              onChange={(e) =>
                                handleRoleToggle(role.Id, e.target.checked)
                              }
                              disabled={isViewMode}
                            />
                            <span className="mi-role-label">{role.Name}</span>
                          </div>

                          {isRoleSelected && (
                            <div className="mi-role-permissions-grid">
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canView || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canView",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can View"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canAdd || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canAdd",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Add"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canEdit || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canEdit",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Edit"
                              />
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canDelete || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canDelete",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                  />
                                }
                                label="Can Delete"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {(roles || []).length === 0 && (
                      <p className="mi-empty-text">No roles available</p>
                    )}
                  </div>
                </div> */}

                <div className="mi-section">
                  <h3 className="mi-section-title">Rolet</h3>

                  <div className="mi-role-list">
                    {(roles || []).map((role) => {
                      const rolePermission = (
                        formData.rolePermissions || []
                      ).find((rp) => rp.roleId === role.Id);
                      const isRoleSelected = !!rolePermission;

                      return (
                        <div key={role.Id} className="mi-role-card">
                          {/* Vetëm header është klikues */}
                          <div
                            className="mi-role-header"
                            onClick={() =>
                              !isViewMode &&
                              handleRoleToggle(role.Id, !isRoleSelected)
                            }
                          >
                            <Checkbox
                              checked={isRoleSelected}
                              onChange={(e) =>
                                handleRoleToggle(role.Id, e.target.checked)
                              }
                              disabled={isViewMode}
                              onClick={(e) => e.stopPropagation()} // E RËNDËSISHME!
                            />

                            <span className="mi-role-label">{role.Name}</span>
                          </div>

                          {/* Permission checkbox-et nuk kanë onClick të kartës */}
                          {isRoleSelected && (
                            <div className="mi-role-permissions-grid">
                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canView || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canView",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Can View"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canAdd || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canAdd",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Can Add"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canEdit || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canEdit",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Can Edit"
                              />

                              <FormControlLabel
                                className="mi-checkbox-row"
                                control={
                                  <Checkbox
                                    checked={rolePermission?.canDelete || false}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        role.Id,
                                        "canDelete",
                                        e.target.checked
                                      )
                                    }
                                    disabled={isViewMode}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                }
                                label="Can Delete"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}

                    {(roles || []).length === 0 && (
                      <p className="mi-empty-text">No roles available</p>
                    )}
                  </div>
                </div>

                {/* Form Actions */}
                {!isViewMode && (
                  <div className="mi-form-actions">
                    <Button
                      type="button"
                      variant="outlined"
                      //   onClick={() => navigate(buildMenuItemsUrl())}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      startIcon={<SaveIcon />}
                    >
                      {mode === "edit" ? "Update" : "Create"}
                    </Button>
                  </div>
                )}
              </CardContent>
            </Card>
          </form>
        </div>
      </div>
    );
  }

  // LIST MODE
  return (
    <div className="menu-items-page">
      <div className="mi-stack mi-stack--lg">
        <div className="mi-header mi-header--responsive">
          <div>
            <h1 className="mi-title">Menu Items</h1>
            <p className="mi-subtitle">
              Manage your application menu structure
            </p>
          </div>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => history.push(buildMenuItemsUrl({ mode: "add" }))}
          >
            Add Menu Item
          </Button>
        </div>

        <Card className="mi-card">
          <CardContent>
            <div className="mi-search-wrapper">
              <FormControl fullWidth size="small" className="mi-search-control">
                <OutlinedInput
                  className="mi-input mi-search-input"
                  placeholder="Search by title or path..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon className="mi-search-icon" />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div className="mi-table-wrapper">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Titulli</TableCell>
                    <TableCell>Path</TableCell>
                    <TableCell>Ikona</TableCell>
                    <TableCell>Numri rendor</TableCell>
                    <TableCell>Global</TableCell>
                    <TableCell>Statusi</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMenuItems.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} className="mi-empty-cell">
                        <p className="mi-empty-text">Nuk ka asnje menu</p>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredMenuItems.map((item) => (
                      <TableRow key={item.MenuID}>
                        <TableCell className="mi-cell-title">
                          {item.Title}
                        </TableCell>
                        <TableCell className="mi-cell-path">
                          {item.Path}
                        </TableCell>
                        <TableCell>{item.Icon || "-"}</TableCell>
                        <TableCell>{item.OrderNo}</TableCell>
                        <TableCell>
                          <div className="mi-status-badges">
                            {item.IsGlobal ? (
                              <span className="status-badge status-badge--active">
                                Global
                              </span>
                            ) : (
                              <span className="status-badge status-badge--inactive">
                                Jo-Global
                              </span>
                            )}
                          </div>
                        </TableCell>

                        <TableCell>
                          <div className="mi-status-badges">
                            {item.IsActive ? (
                              <span className="status-badge status-badge--active">
                                Active
                              </span>
                            ) : (
                              <span className="status-badge status-badge--inactive">
                                Inactive
                              </span>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right">
                          <div className="mi-actions">
                            {/* <Button
                              variant="text"
                              size="small"
                              onClick={() =>
                                history.push(
                                  buildMenuItemsUrl({
                                    mode: "view",
                                    id: item.MenuID,
                                  })
                                )
                              }
                            >
                              <VisibilityIcon className="mi-icon" />
                            </Button> */}
                            {/* <Button
                              variant="text"
                              size="small"
                                onClick={() =>
                                  navigate(
                                    buildMenuItemsUrl({
                                      mode: "edit",
                                      id: item.id,
                                    })
                                  )
                                }
                            >
                              <EditIcon className="mi-icon" />
                            </Button> */}
                            <Button
                              variant="text"
                              size="small"
                              onClick={() => openDeleteDialog(item)}
                            >
                              <DeleteIcon className="mi-icon" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>

      <Dialog open={deleteDialogOpen} onClose={closeDeleteDialog}>
        <DialogTitle>Delete Menu Item</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete "{itemToDelete?.title}"? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog}>Cancel</Button>
          <Button
            onClick={confirmDelete}
            className="mi-btn-danger"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
